import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { LogService } from 'common-components';

@Injectable()
// eslint-disable-next-line
export class i18nInterceptor implements HttpInterceptor {
    private translate: TranslateService;
    private logService: LogService;

    constructor(private injector: Injector) { }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let requestToForward = req;

        if (this.translate === undefined) {
            this.translate = this.injector.get<TranslateService>(TranslateService);
        }

        if (this.logService === undefined) {
            this.logService = this.injector.get<LogService>(LogService);
        }

        if (this.translate) {
            const language = this.translate.currentLang;
            if (language) {
                requestToForward = req.clone({ setHeaders: { 'Accept-Language': language } });
            }
        } else {
            this.logService.warn('TranlateService undefined: Language will NOT be set to selected value.');
        }

        return next.handle(requestToForward);
    }
}
